import PresetPage from './preset.page';

export default PresetPage;
